module.exports = __webpack_public_path__ + "static/img/banner_img_02.87df6ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/pc/banner_img_02.png
// module id = xE7x
// module chunks = 0